import React, { useState } from 'react';
import { SUCURSAL_NOMBRES } from '../../constants';
import { presentarEmpleado } from './TarjetaEmpleado';

// Credencial compacta (M.2A.1): cabecera del expediente Mobile. Identidad,
// puesto, área y sucursal salen de la lista de App.jsx (disponibles al
// instante). `foto` es la foto_url del detalle (M.2B): si falta o falla la
// imagen se usan las iniciales.
export function CredencialEmpleado({ empleado, foto }) {
  const p = presentarEmpleado(empleado);
  // Sólo se muestra si el código resuelve de forma segura; nunca se inventa.
  const sucursal = SUCURSAL_NOMBRES[String(empleado.sucursal || '').trim()] || '';
  const ubicacion = [p.area, sucursal].filter(Boolean).join(' · ');
  const [fotoFallida, setFotoFallida] = useState(null);
  const mostrarFoto = foto && fotoFallida !== foto;

  return (
    <article className="m-cred" aria-labelledby="m-cred-nombre">
      <div className="m-cred-id">
        <div className={`m-cred-avatar m-tono-${p.estatus.tipo}${mostrarFoto ? ' m-cred-avatar-foto' : ''}`} aria-hidden="true">
          {mostrarFoto
            ? <img src={foto} alt="" onError={() => setFotoFallida(foto)} />
            : (p.iniciales || <i className="ti ti-user"></i>)}
        </div>
        <div className="m-cred-ident">
          <h1 id="m-cred-nombre" className="m-cred-nombre">{(p.nombre || 'Sin nombre').toUpperCase()}</h1>
          <div className="m-cred-linea">
            {p.id && <span className="m-cred-num"><span className="m-sr-only">Número de empleado </span>#{p.id}</span>}
            <span className={`m-cred-badge m-cred-badge-${p.estatus.tipo}`}>
              <span className="m-estatus-punto" aria-hidden="true"></span>{p.textoEstatus}
            </span>
          </div>
        </div>
      </div>
      {(p.puesto || ubicacion) && (
        <dl className="m-cred-laboral">
          {p.puesto && (
            <div className="m-cred-puesto"><dt className="m-sr-only">Puesto</dt><dd>{p.puesto}</dd></div>
          )}
          {ubicacion && (
            <div className="m-cred-ubicacion">
              <dt className="m-sr-only">{[p.area && 'Área', sucursal && 'Sucursal'].filter(Boolean).join(' y ')}</dt>
              <dd>{ubicacion}</dd>
            </div>
          )}
        </dl>
      )}
    </article>
  );
}
